import axios from 'axios'
import CONFIG from '../../config'

export async function handleLogin (username, password) {
  try {
    const result = await axios.post(`${CONFIG.api_url}/login`, {
      username,
      password
    })
    if (result.status === 200) {
      return result.data
    } else return
  } catch (error) {
    console.log(error.message)
  }
}

export async function validateToken (token) {
  const config = {
    headers: {
      Authorization: 'Bearer ' + token
    }
  }
  try {
    const result = await axios.get(`${CONFIG.api_url}/validate`, config)
    return result?.status === 200
  } catch (error) {
    console.log(error.message)
    return false
  }
}
